import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { device } from '../../styles/mixins';

const Container = styled.div`
  margin: 1rem 90px 2rem;
  font-size: 22px;
  line-height: 1.8;
  color: #4a4a4a;
  max-width: 715px;

  @media ${device.phoneOnly} {
    margin: 1rem 24px;
  }
`;

const ContentContainer = ({ children }) => <Container>{children}</Container>;

ContentContainer.propTypes = {
  children: PropTypes.any,
};

ContentContainer.defaultProps = {};

export default ContentContainer;
